





























import { Component, Vue } from "vue-property-decorator";
@Component({
  name: "chrome-exclusive-component",
})
export default class ChromeExclusiveComponent extends Vue {
  urlAndroid = "https://play.google.com/store/apps/details?id=com.nubiapp";
  urlIplone = "https://apps.apple.com/es/app/nubi-city/id6443933977?l=en";
  deviceIphone = "iphone";
  deviceAndroid = "android";
  isIplone = false;
  isAndroid = false;
  mounted(): void {
    const uagent = navigator.userAgent.toLowerCase();
    this.isAndroid = uagent.search(this.deviceAndroid) > -1 ? true : false;
    this.isIplone = uagent.search(this.deviceIphone) > -1 ? true : false;
  }
  isHawkings(): boolean {
    if (window.location.host.includes("hawkings.education")) return true;
    else return false;
  }
}
